import {
  Box,
  FormControl,
  Input,
  CardContent,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Card,
  TextField,
  Checkbox,
  Button,
  Paper,
  CircularProgress,
  createTheme,
} from "@mui/material"
import { ChangeEvent, useState, useEffect } from "react"
import { Trans, useTranslation } from "react-i18next"
import { BooleanUtils } from "../utils/BooleanUtils"
import { RaisonsSansNeq } from "../model/RaisonsSansNeq"
import ContactForm from "./SecondaryForms/ContactForm"
import RepresentantForm from "./SecondaryForms/RepresentantForm"
import { Contact } from "../model/Contact"
import { initialState as initialStatePlainte } from "./InitialStates/PlainteInitialState"
import { Representant } from "../model/Representant"
import { Processus } from "../model/Processus"
import { DatePicker } from "@mui/x-date-pickers"
import { RepresentantOrganismePublic } from "../model/RepresentantOrganismePublic"
import AppelOffreForm from "./SecondaryForms/AppelOffreForm"
import { AppelOffreSeao } from "../model/AppelOffreSeao"
import axios from "axios"
import RepresentantOrganismePublicCRUDForm from "./SecondaryForms/RepresentantOrganismePublicCRUDForm"
import Turnstile, { useTurnstile } from "react-turnstile"
import "./CSS/colorMessages.css"
import appendObjectToFormData from '../utils/useFormData'
import { useNavigate } from "react-router-dom"

const FormulairePlaintes = () => {
  let navigate = useNavigate()
  const [plainte, setPlainte] = useState(initialStatePlainte)
  const [reCaptchaRequest, setReCaptcha] = useState({ reCaptchaToken: "", remoteip: null })
  const [successForm, setSuccessForm] = useState("")
  const [errorSubmission, setErrorSubmission] = useState("")
  const [errorNom, setErrorNom] = useState("")
  const [errorNeq, setErrorNeq] = useState("")
  const [errorNeqFormat, setErrorNeqFormat] = useState("")
  const [errorContactNom, setErrorContactNom] = useState("")
  const [errorContactPrenom, setErrorContactPrenom] = useState("")
  const [errorContactCourriel, setErrorContactCourriel] = useState("")
  const [errorContactTelephone, setErrorContactTelephone] = useState("")
  const [errorRepresentantNomPlaignant, setErrorRepresentantNomPlaignant] = useState("")
  const [errorRepresentantNom, setErrorRepresentantNom] = useState("")
  const [errorRepresentantPrenom, setErrorRepresentantPrenom] = useState("")
  const [errorRepresentantTitre, setErrorRepresentantTitre] = useState("")
  const [errorRepresentantCourriel, setErrorRepresentantCourriel] = useState("")
  const [errorRepresentantTelephone, setErrorRepresentantTelephone] = useState("")
  const [errorInteret, setErrorInteret] = useState("")
  const [errorOrdonnance, setErrorOrdonnance] = useState("")
  const [errorAntecedent, setErrorAntecedent] = useState("")
  const [errorNomOrganisme, setErrorNomOrganisme] = useState("")
  const [errorTypeDemande, setErrorTypeDemande] = useState("")
  const [errorFichier, setErrorFichier] = useState("")
  const [
    errorAttestationVeraciteInformations,
    setErrorAttestationVeraciteInformations,
  ] = useState("")
  const [errorNumeroReference, setErrorNumeroReference] = useState("")
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const { t } = useTranslation()
  const [saved, setSaved] = useState(false)
  const [loading, setLoading] = useState(false)

  const decodeHtmlEntities = (text: string | null = ''): string => {
    return text 
      ? text
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
      : '';
  };

  const goToConfirmation = () => {
    return navigate("/confirmation")
  }

  useEffect(() => {
    document.title = "Plainte"
  }, [])

  const handleOuiNonQuestionChange = (event: any) => {
    const { name, value } = event.target
    setPlainte((prevState) => {
      return {
        ...prevState,
        [name]: BooleanUtils.fromStringToBoolean(value),
      }
    })
  }

  const handleOuiNonQuestionChangeNEQ = (event: any) => {
    const { value } = event.target
    setPlainte((prevState) => {
      return {
        ...prevState,
        ['avecNeq']: BooleanUtils.fromStringToBoolean(value),
      }
    })
    if (!BooleanUtils.fromStringToBoolean(value)) {
      setErrorNeqFormat("")
    }
    else {
      var regexNeq = /^(11|22|33)[0-9]{8}$/
      if (plainte.neq !== "" && !regexNeq.test(plainte.neq)) {
        setErrorNeqFormat(t("messagesUtilisateurs.lblFormatNEQ"))
      }
    }
  }

  const handleContactChange = (updatedContact: Contact) => {
    setPlainte((prevState) => ({
      ...prevState,
      contact: updatedContact,
    }))
  }

  const handleAttestationVeraciteOnChange = (event: any) => {
    setPlainte((prevState) => {
      return {
        ...prevState,
        ['attestationDeLaVeracite']: !plainte.attestationDeLaVeracite,
      }
    })
  }

  const TurnstileWidget = () => {
    const turnstile = useTurnstile()
    return (
      <Turnstile
        sitekey="0x4AAAAAAATUkYKisAyqVMcx"
        onVerify={async (token) => {
          const res = await axios.get("https://api.ipify.org/?format=json")
          setReCaptcha({ reCaptchaToken: token, remoteip: res.data.ip })
        }}
      />
    )
  }

  const handleOnRepresentantChange = (updatedRepresentant: Representant) => {
    setPlainte((prevState) => ({
      ...prevState,
      representant: updatedRepresentant,
    }))
  }

  const handleOnRepresentantOPChange = (
    updatedRepresentantsOP: RepresentantOrganismePublic[]
  ) => {
    setPlainte((prevState) => ({
      ...prevState,
      representantsOrganismePublic: updatedRepresentantsOP,
    }))
  }

  const handleSEAOFormChange = (appelOffre: AppelOffreSeao) => {
    setPlainte((prevState) => ({
      ...prevState,
      appelOffre: appelOffre,
    }))
  }

  const handleOnChange = (event: any) => {
    const { name, value } = event.target
    setPlainte((prevState) => {
      return {
        ...prevState,
        [name]: value,
      }
    })
  }

  useEffect(() => {
    handleErrors()
  }, [plainte])

  useEffect(() => {
    handleErrors()
  }, [selectedFile])

  const handleFileSelect = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedFile(event.target.files[0])
    } else {
      setSelectedFile(null)
    }
  }

  const handleErrors = () => {
    if (errorNom === t("messagesUtilisateurs.lblChampRequis") && plainte.personneAddressantPlainte !== "") {
      setErrorNom("")
    }
    if (errorNeq === t("messagesUtilisateurs.lblChampRequis") && plainte.avecNeq !== null) {
      setErrorNeq("")
    }
    if (plainte.avecNeq) {
      if (errorNeqFormat === t("messagesUtilisateurs.lblChampRequis") && plainte.neq !== "") {
        setErrorNeqFormat("")
      }
    }
    if (errorContactNom === t("messagesUtilisateurs.lblChampRequis") && plainte.contact.nom !== "") {
      setErrorContactNom("")
    }
    if (errorContactPrenom === t("messagesUtilisateurs.lblChampRequis") && plainte.contact.prenom !== "") {
      setErrorContactPrenom("")
    }
    if (errorContactCourriel === t("messagesUtilisateurs.lblChampRequis") && plainte.contact.courriel !== "") {
      setErrorContactCourriel("")
    }
    if (errorContactTelephone === t("messagesUtilisateurs.lblChampRequis") && plainte.contact.telephone !== "") {
      setErrorContactTelephone("")
    }
    if (
      plainte.representant.nomRepresentantPlaignant !== "" ||
      plainte.representant.nomPersonneAContacter !== "" ||
      plainte.representant.prenomPersonneAContacter !== "" ||
      plainte.representant.titrePersonneAContacter !== "" ||
      plainte.representant.courrielPersonneAContacter !== "" ||
      plainte.representant.telephonePersonneAContacter !== ""
    ) {
      if (errorRepresentantNomPlaignant === t("messagesUtilisateurs.lblChampRequis") && plainte.representant.nomRepresentantPlaignant !== "") {
        setErrorRepresentantNomPlaignant("")
      }
      if (errorRepresentantNom === t("messagesUtilisateurs.lblChampRequis") && plainte.representant.nomPersonneAContacter !== "") {
        setErrorRepresentantNom("")
      }
      if (errorRepresentantPrenom === t("messagesUtilisateurs.lblChampRequis") && plainte.representant.prenomPersonneAContacter !== "") {
        setErrorRepresentantPrenom("")
      }
      if (errorRepresentantTitre === t("messagesUtilisateurs.lblChampRequis") && plainte.representant.titrePersonneAContacter !== "") {
        setErrorRepresentantTitre("")
      }
      if (errorRepresentantCourriel === t("messagesUtilisateurs.lblChampRequis") && plainte.representant.courrielPersonneAContacter !== "") {
        setErrorRepresentantCourriel("")
      }
      if (errorRepresentantTelephone === t("messagesUtilisateurs.lblChampRequis") && plainte.representant.telephonePersonneAContacter !== "") {
        setErrorRepresentantTelephone("")
      }
    }
    if (errorAttestationVeraciteInformations === t("messagesUtilisateurs.lblChampRequis") && plainte.attestationDeLaVeracite) {
      setErrorAttestationVeraciteInformations("")
    }
    if (errorInteret === t("messagesUtilisateurs.lblChampRequis") && plainte.interetProcessusAdjucationAttribution !== null) {
      setErrorInteret("")
    }
    if (errorOrdonnance === t("messagesUtilisateurs.lblChampRequis") && plainte.ordonnanceOuRecommandationAmp !== null) {
      setErrorOrdonnance("")
    }
    if (errorAntecedent === t("messagesUtilisateurs.lblChampRequis") && plainte.antecedentExerciceRecoursJudiciaire !== null) {
      setErrorAntecedent("")
    }
    if (errorNomOrganisme === t("messagesUtilisateurs.lblChampRequis") && plainte.nomOrganismeResponsableProcessusAdjucation !== "") {
      setErrorNomOrganisme("")
    }
    if (errorTypeDemande === t("messagesUtilisateurs.lblChampRequis") && plainte.typeDemande !== "") {
      setErrorTypeDemande("")
    }
    if (errorFichier === t("messagesUtilisateurs.lblTailleFichier") && validerTailleFichier()) {
      setErrorFichier("")
    }
  }

  const handleFormatErrors = (fieldName: string) => {
    var regexNeq = /^(11|22|33)[0-9]{8}$/
    var regexCourriel =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    var regexTelephone =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
    var regexNumeroReference = /^[0-9]*$/
    if (fieldName === "neq") {
      if (plainte.avecNeq) {
        if (!regexNeq.test(plainte.neq)) {
          setErrorNeqFormat(t("messagesUtilisateurs.lblFormatNEQ"))
        }
        else setErrorNeqFormat("")
      }
    }
    else if (fieldName === "courriel") {
      if (
        plainte.contact.courriel !== "" &&
        !regexCourriel.test(plainte.contact.courriel)
      ) {
        setErrorContactCourriel(
          t("messagesUtilisateurs.lblContactFormatCourriel")
        )
      } else setErrorContactCourriel("")
    }
    else if (fieldName === "telephone") {
      if (
        plainte.contact.telephone !== "" &&
        !regexTelephone.test(plainte.contact.telephone)
      ) {
        setErrorContactTelephone(
          t("messagesUtilisateurs.lblContactFormatTelephone")
        )
      } else setErrorContactTelephone("")
    }
    else if (fieldName === "numeroReference") {
      if (plainte.appelOffre.numeroReference !== "" && !regexNumeroReference.test(plainte.appelOffre.numeroReference)) {
        setErrorNumeroReference(
          t("messagesUtilisateurs.lblFormatNumeroReference")
        )
      } else setErrorNumeroReference("")
    }
  }

  const handleSubmit = async () => {
    let error = false
    if (plainte.personneAddressantPlainte === "") {
      setErrorNom(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorNom("")
    if (plainte.avecNeq === null) {
      setErrorNeq(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorNeq("")
    if (plainte.avecNeq) {
      var regexNeq = /^(11|22|33)[0-9]{8}$/
      if (plainte.neq === "") {
        setErrorNeqFormat(t("messagesUtilisateurs.lblChampRequis"))
      }
      else if (!regexNeq.test(plainte.neq)) {
        setErrorNeqFormat(t("messagesUtilisateurs.lblFormatNEQ"))
      } else setErrorNeqFormat("")
    }
    var regexCourriel =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    var regexTelephone =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
    if (plainte.contact.nom === "") {
      setErrorContactNom(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorContactNom("")
    if (plainte.contact.prenom === "") {
      setErrorContactPrenom(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorContactPrenom("")
    if (plainte.contact.courriel === "") {
      setErrorContactCourriel(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorContactCourriel("")
    if (plainte.contact.telephone === "") {
      setErrorContactTelephone(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorContactTelephone("")
    if (
      plainte.contact.courriel !== "" &&
      !regexCourriel.test(plainte.contact.courriel)
    ) {
      setErrorContactCourriel(
        t("messagesUtilisateurs.lblContactFormatCourriel")
      )
      error = true
    } else if (plainte.contact.courriel !== "") setErrorContactCourriel("")
    if (
      plainte.contact.telephone !== "" &&
      !regexTelephone.test(plainte.contact.telephone)
    ) {
      setErrorContactTelephone(
        t("messagesUtilisateurs.lblContactFormatTelephone")
      )
      error = true
    } else if (plainte.contact.telephone !== "") setErrorContactTelephone("")
    if (
      plainte.representant.nomRepresentantPlaignant !== "" ||
      plainte.representant.nomPersonneAContacter !== "" ||
      plainte.representant.prenomPersonneAContacter !== "" ||
      plainte.representant.titrePersonneAContacter !== "" ||
      plainte.representant.courrielPersonneAContacter !== "" ||
      plainte.representant.telephonePersonneAContacter !== ""
    ) {
      if (plainte.representant.nomRepresentantPlaignant === "") {
        setErrorRepresentantNomPlaignant(t("messagesUtilisateurs.lblChampRequis"))
        error = true
      } else setErrorRepresentantNomPlaignant("")
      if (plainte.representant.nomPersonneAContacter === "") {
        setErrorRepresentantNom(t("messagesUtilisateurs.lblChampRequis"))
        error = true
      } else setErrorRepresentantNom("")
      if (plainte.representant.prenomPersonneAContacter === "") {
        setErrorRepresentantPrenom(t("messagesUtilisateurs.lblChampRequis"))
        error = true
      } else setErrorRepresentantPrenom("")
      if (plainte.representant.titrePersonneAContacter === "") {
        setErrorRepresentantTitre(t("messagesUtilisateurs.lblChampRequis"))
        error = true
      } else setErrorRepresentantTitre("")
      if (plainte.representant.courrielPersonneAContacter === "") {
        setErrorRepresentantCourriel(t("messagesUtilisateurs.lblChampRequis"))
        error = true
      } else setErrorRepresentantCourriel("")
      if (plainte.representant.telephonePersonneAContacter === "") {
        setErrorRepresentantTelephone(t("messagesUtilisateurs.lblChampRequis"))
        error = true
      } else setErrorRepresentantTelephone("")
      if (
        plainte.representant.courrielPersonneAContacter !== "" &&
        !regexCourriel.test(plainte.representant.courrielPersonneAContacter)
      ) {
        setErrorRepresentantCourriel(
          t("messagesUtilisateurs.lblContactFormatCourriel")
        )
        error = true
      } else if (plainte.representant.courrielPersonneAContacter !== "") setErrorRepresentantCourriel("")
      if (
        plainte.representant.telephonePersonneAContacter !== "" &&
        !regexTelephone.test(plainte.representant.telephonePersonneAContacter)
      ) {
        setErrorRepresentantTelephone(
          t("messagesUtilisateurs.lblContactFormatTelephone")
        )
        error = true
      } else if (plainte.representant.telephonePersonneAContacter !== "") setErrorRepresentantTelephone("")
    }
    if (!plainte.attestationDeLaVeracite) {
      setErrorAttestationVeraciteInformations(
        t("messagesUtilisateurs.lblChampRequis")
      )
      error = true
    } else setErrorAttestationVeraciteInformations("")
    var regexNumeroReference = /^[0-9]*$/
    if (
      plainte.appelOffre.numeroSeao !== "" ||
      plainte.appelOffre.numeroReference !== "" ||
      plainte.appelOffre.titreAvis !== ""
    ) {
      if (!regexNumeroReference.test(plainte.appelOffre.numeroReference)) {
        setErrorNumeroReference(
          t("messagesUtilisateurs.lblFormatNumeroReference")
        )
      }
    }
    if (plainte.interetProcessusAdjucationAttribution === null) {
      setErrorInteret(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorInteret("")
    if (plainte.ordonnanceOuRecommandationAmp === null) {
      setErrorOrdonnance(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorOrdonnance("")
    if (plainte.antecedentExerciceRecoursJudiciaire === null) {
      setErrorAntecedent(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorAntecedent("")
    if (plainte.nomOrganismeResponsableProcessusAdjucation === "") {
      setErrorNomOrganisme(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorNomOrganisme("")
    if (plainte.typeDemande === "") {
      setErrorTypeDemande(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorTypeDemande("")
    if (selectedFile) {
      if (!validerTailleFichier()) {
        setErrorFichier(t("messagesUtilisateurs.lblTailleFichier"))
        error = true
      } else setErrorFichier("")
    }
    if (error) setErrorSubmission(t("messagesUtilisateurs.lblErreurChampsFormulaire"))
    if (!error) {
      if (plainte.recuDecisionOrganismePublic == null) {
        plainte.recuDecisionOrganismePublic = false
      }
      if (plainte.porterPlainteOrganismePublicAvantAMP == null) {
        plainte.porterPlainteOrganismePublicAvantAMP = false
      }
      plainte.prenomPlaignant = plainte.contact.prenom;
      plainte.nomPlaignant = plainte.contact.nom;
      plainte.datePlainte = new Date().toISOString();
      const formData = new FormData()
      formData.append('files', selectedFile)
      appendObjectToFormData(formData, 'plainteForm', plainte)
      appendObjectToFormData(formData, 'contactForm', plainte.contact)
      appendObjectToFormData(formData, 'representantForm', plainte.representant)
      appendObjectToFormData(formData, 'appelOffreForm', plainte.appelOffre)
      appendObjectToFormData(formData, 'representantsDetailsOrganismePublicForm', plainte.representantsOrganismePublic)
      appendObjectToFormData(formData, 'reCaptchaRequest', reCaptchaRequest)
      formData.append('nomFormulaire', 'Plainte')
      formData.append('nomEntrepriseOuIndividu', plainte.personneAddressantPlainte)
      formData.append('adresseCourriel', plainte.contact.courriel)

      setLoading(true)
      setSaved(true)
      axios
        .post(
          process.env.REACT_APP_API_URL + "/v1/TraiterFormulaires/upload",
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          }
        )
        .then((response) => {
          setSaved(true)
          setSuccessForm(t("messagesUtilisateurs.lblSuccesSoumission"))
          setErrorSubmission("")
          goToConfirmation()
        })
        .catch((error) => {
          setSaved(false)
          setSuccessForm("")
          setErrorSubmission(t("messagesUtilisateurs.lblErreurEnvoiFormulaire"))
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          })
        }).finally(() => {
          setLoading(false)
        })
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }
  const onChangeDateReception = (value: Date | null) => {
    setPlainte((prevState) => {
      return {
        ...prevState,
        dateDeReceptionDetailsOrganismePublic: value.toISOString(),
      }
    })
  }
  const getChampNeq = (afficherChamps: boolean): JSX.Element | null => {
    return afficherChamps ? (
      <FormControl fullWidth>
        <TextField
          label="NEQ"
          name="neq"
          title={t("formulairePlaintes.identificationPlaignantRep.lblChampNEQ")}
          value={decodeHtmlEntities(plainte.neq || '')}
          onChange={handleOnChange}
          onBlur={() => handleFormatErrors("neq")}
          required

          aria-describedby="neq-format-error"
          style={{ backgroundColor: errorNeqFormat ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
        />
      </FormControl>
    ) : null
  }
  const getChampRaisonSansNeq = (
    afficherChamps: boolean
  ): JSX.Element | null => {
    return afficherChamps ? (
      <FormControl fullWidth>
        <FormLabel id="radio-raison-group-label">
          <Trans>
            {t(
              "formulairePlaintes.identificationPlaignantRep.lblChampRaisonNonNEQ"
            )}
          </Trans>
        </FormLabel>
        <RadioGroup
          row
          aria-labelledby="radio-raison-group-label"
          name="raisonSansNeq"
          onChange={handleOnChange}
        >
          <FormControlLabel
            value={RaisonsSansNeq.EntrepriseHorsQuebec}
            control={<Radio />}
            label={
              <Trans>
                {t(
                  "formulairePlaintes.identificationPlaignantRep.lblChampRaisonNonNEQRadioEntrepriseHorsQuebec"
                )}
              </Trans>
            }
          />
          <FormControlLabel
            value={RaisonsSansNeq.Autre}
            control={<Radio />}
            label={
              <Trans>
                {t(
                  "formulairePlaintes.identificationPlaignantRep.lblChampRaisonNonNEQRadioAutre"
                )}
              </Trans>
            }
          />
        </RadioGroup>
      </FormControl>
    ) : null
  }
  const getChampRaisonAutreSansNeq = (
    afficherChamps: boolean
  ): JSX.Element | null => {
    return afficherChamps ? (
      <FormControl fullWidth>
        <TextField
          name="precisionSansNeq"
          label={
            <Trans>
              {t("formulairePlaintes.identificationPlaignantRep.lblPrecision")}
            </Trans>
          }
          id="raison-autre"

          onChange={handleOnChange}
          value={decodeHtmlEntities(plainte.precisionSansNeq || '')}
        />
      </FormControl>
    ) : null
  }

  const handleOnChangeTypeDemande = (event: any) => {
    const { name, value } = event.target
    setPlainte((prevState) => {
      return {
        ...prevState,
        ["desaccordDecision"]: false,
        ["decisionNonRecue"]: false,
        ["documentsModifiesDurantPeriodeAvantDateLimiteOuAvisIntentionNonPublie"]: false,
        ["aucuneSituation"]: false,
      }
    })
    setPlainte((prevState) => {
      return {
        ...prevState,
        [name]: value,
      }
    })
  }

  const handleOuiNonCheckboxMotifPlainteChange = (event: any) => {
    const name = event.target.name

    setPlainte((prevState) => {
      return {
        ...prevState,
        [name]: event.target.checked,
      }
    })
  }

  const validerTailleFichier = (): boolean => {
    if (selectedFile) {
      const TAILLE_MAX_FICHIER_MB = 6;
      const tailleFichierMB = selectedFile.size / (1024 * 1024);
      return (tailleFichierMB <= TAILLE_MAX_FICHIER_MB);
    } else {
      return true;
    }
  }

  const theme = createTheme({
    components: {

      // Name of the component
      MuiTextField: {
        defaultProps: {
          // The props to change the default for.
          variant: "filled"
        },
        styleOverrides: {
          // Name of the slot
          root: {
            // Some CSS
            marginBottom: '1rem',
          },
        },
      },

    },
  });


  return (
    <>
      <Card className="card" sx={{ minWidth: 275 }}>
        <CardContent>
          <Box component="form" >

            {successForm && (
              <strong id="form-success" role="alert" className="success">
                <Trans>{successForm}</Trans>
              </strong>
            )}
            {errorSubmission && (
              <strong id="error-submission" role="alert" className="error">
                <Trans>{errorSubmission}</Trans>
              </strong>
            )}

            <h1>
              <Trans>{t("formulairePlaintes.lblPage")}</Trans>
            </h1>
            <div className="amp-alert amp-alert--warning">
              <div className="amp-alert__body">
                <div className="field">
                  <p><Trans>{t("formulairePlaintes.info")}</Trans></p>
                </div>
              </div>
            </div>
            <fieldset>
              <FormControl fullWidth >

                <legend>

                  <Trans>
                    {t("formulairePlaintes.identificationPlaignantRep.lblSection")}
                  </Trans>

                </legend>
                <TextField required id="nom-entreprise"
                  name="personneAddressantPlainte"
                  label={
                    <Trans>
                      {t(
                        "formulairePlaintes.identificationPlaignantRep.lblChampNomEntreprise"
                      )}
                    </Trans>
                  }

                  onChange={handleOnChange}
                  value={decodeHtmlEntities(plainte.personneAddressantPlainte || '')}
                  aria-describedby="nom-entreprise-error"
                  style={{ backgroundColor: errorNom ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                />
                {errorNom && (
                  <strong id="nom-entreprise-error" role="alert" className="error">
                    <Trans>{errorNom}</Trans>
                  </strong>
                )}
              </FormControl>

              <FormControl fullWidth>
                <FormLabel required id="radio-neq-group-label">
                  <Trans>
                    {t(
                      "formulairePlaintes.identificationPlaignantRep.lblChampNEQQuestion"
                    )}
                  </Trans>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="radio-neq-group-label"
                  name="avecNeq"
                  onChange={handleOuiNonQuestionChangeNEQ}
                  aria-describedby="neq-error"
                  style={{ backgroundColor: errorNeq ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                >
                  <FormControlLabel value="oui" control={<Radio />} label={<Trans>{t('Oui')}</Trans>} />
                  <FormControlLabel value="non" control={<Radio />} label={<Trans>{t('Non')}</Trans>} />
                </RadioGroup>
                {errorNeq && (
                  <strong id="neq-error" role="alert" className="error">
                    <Trans>{errorNeq}</Trans>
                  </strong>
                )}
                {getChampNeq(plainte.avecNeq || false)}
                {errorNeqFormat && (
                  <strong id="neq-format-error" role="alert" className="error">
                    <Trans>{errorNeqFormat}</Trans>
                  </strong>
                )}
                {getChampRaisonSansNeq(
                  plainte.avecNeq !== null && !plainte.avecNeq
                )}
                {getChampRaisonAutreSansNeq(
                  plainte.avecNeq !== null &&
                  !plainte.avecNeq &&
                  plainte.raisonSansNeq === RaisonsSansNeq.Autre
                )}
              </FormControl>


              <div className="form-text-label">
                <Trans>
                  {t(
                    "formulairePlaintes.identificationPlaignantRep.lblSectionContact"
                  )}
                </Trans>
              </div>

              <ContactForm
                contact={plainte.contact}
                onChange={handleContactChange}
                onBlur={handleFormatErrors}
                errorContactNom={errorContactNom}
                errorContactPrenom={errorContactPrenom}
                errorContactCourriel={errorContactCourriel}
                errorContactTelephone={errorContactTelephone}
              />

              <div className="form-text-label">
                <Trans>
                  {t(
                    "formulairePlaintes.identificationPlaignantRep.lblSectionRepresentant"
                  )}
                </Trans>
              </div>

              <RepresentantForm
                representant={plainte.representant}
                onChange={handleOnRepresentantChange}
                errorRepresentantNomPlaignant={errorRepresentantNomPlaignant}
                errorRepresentantNom={errorRepresentantNom}
                errorRepresentantPrenom={errorRepresentantPrenom}
                errorRepresentantTitre={errorRepresentantTitre}
                errorRepresentantCourriel={errorRepresentantCourriel}
                errorRepresentantTelephone={errorRepresentantTelephone}
              />

              <div className="form-attestation-container">

                <Paper elevation={0}>

                  <FormControl fullWidth>
                    <div className="form-attestation">
                      <div className="form-text-label-no-margin">
                        <Trans>{t("attestations.veraciteRenseignement.lbl")}</Trans>
                      </div>
                      <FormControlLabel
                        required
                        control={<Checkbox />}
                        label={
                          <Trans>
                            {t("attestations.veraciteRenseignement.message")}{" "}
                          </Trans>
                        }
                        name="attestationDeLaVeracite"
                        value={plainte.attestationDeLaVeracite}
                        onChange={handleAttestationVeraciteOnChange}
                        aria-describedby="attestation-veracite-error"
                        style={{ backgroundColor: errorAttestationVeraciteInformations ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                      />
                    </div>
                  </FormControl>
                </Paper>
              </div>

              {errorAttestationVeraciteInformations && (
                <strong
                  id="attestation-veracite-error"
                  role="alert"
                  className="error"
                >
                  <Trans>{errorAttestationVeraciteInformations}</Trans>
                </strong>
              )}
            </fieldset>

            <fieldset>
              <legend>

                <Trans>
                  {t(
                    "formulairePlaintes.renseignementsContextePlainte.lblSection"
                  )}
                </Trans>

              </legend>
              <FormControl fullWidth>
                <FormLabel required id="radio-interet-group-label">
                  <Trans>
                    {t(
                      "formulairePlaintes.renseignementsContextePlainte.lblChampInteret"
                    )}
                  </Trans>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="radio-interet-group-label"
                  name="interetProcessusAdjucationAttribution"
                  onChange={handleOuiNonQuestionChange}
                  aria-describedby="interet-error"
                  style={{ backgroundColor: errorInteret ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                >
                  <FormControlLabel value="oui" control={<Radio />} label={<Trans>{t('Oui')}</Trans>} />
                  <FormControlLabel value="non" control={<Radio />} label={<Trans>{t('Non')}</Trans>} />
                </RadioGroup>
              </FormControl>
              {errorInteret && (
                <strong id="interet-error" role="alert" className="error">
                  <Trans>{errorInteret}</Trans>
                </strong>
              )}
              <div className="form-div-no-margin">
                <FormControl fullWidth>
                  <TextField
                    name="raisonNonParticipationProcessus"
                    label={
                      <Trans>
                        {t(
                          "formulairePlaintes.renseignementsContextePlainte.lblChampRaisonNonInteret"
                        )}
                      </Trans>
                    }
                    multiline
                    rows={4}
                    onChange={handleOnChange}
                    value={decodeHtmlEntities(plainte.raisonNonParticipationProcessus || '')}
                  />
                </FormControl>
              </div>
              <FormControl fullWidth>
                <FormLabel required id="radio--modification-plainte-group-label">
                  <Trans>
                    {t(
                      "formulairePlaintes.renseignementsContextePlainte.lblChampModificationPlainte"
                    )}
                  </Trans>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="radio--modification-plainte-group-label"
                  name="ordonnanceOuRecommandationAmp"
                  onChange={handleOuiNonQuestionChange}
                  aria-describedby="ordonnance-error"
                  style={{ backgroundColor: errorOrdonnance ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                >
                  <FormControlLabel value="oui" control={<Radio />} label={<Trans>{t('Oui')}</Trans>} />
                  <FormControlLabel value="non" control={<Radio />} label={<Trans>{t('Non')}</Trans>} />
                </RadioGroup>
              </FormControl>
              {errorOrdonnance && (
                <strong id="ordonnance-error" role="alert" className="error">
                  <Trans>{errorOrdonnance}</Trans>
                </strong>
              )}
              <FormControl fullWidth>
                <FormLabel required id="radio-recours-judiciaire-group-label">
                  <Trans>
                    {t(
                      "formulairePlaintes.renseignementsContextePlainte.lblChampRecoursJudiciaire"
                    )}
                  </Trans>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="radio-recours-judiciaire-group-label"
                  name="antecedentExerciceRecoursJudiciaire"
                  onChange={handleOuiNonQuestionChange}
                  aria-describedby="antecedent-error"
                  style={{ backgroundColor: errorAntecedent ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                >
                  <FormControlLabel value="oui" control={<Radio />} label={<Trans>{t('Oui')}</Trans>} />
                  <FormControlLabel value="non" control={<Radio />} label={<Trans>{t('Non')}</Trans>} />
                </RadioGroup>
              </FormControl>
              {errorAntecedent && (
                <strong id="antecedent-error" role="alert" className="error">
                  <Trans>{errorAntecedent}</Trans>
                </strong>
              )}
              <div className="form-div-no-margin">
                <FormControl fullWidth>
                  <TextField required
                    name="nomOrganismeResponsableProcessusAdjucation"
                    label={
                      <Trans>
                        {t(
                          "formulairePlaintes.renseignementsContextePlainte.lblChampNomOrganismePublic"
                        )}
                      </Trans>
                    }

                    onChange={handleOnChange}
                    value={decodeHtmlEntities(plainte.nomOrganismeResponsableProcessusAdjucation || '')}
                    aria-describedby="nom-organisme-error"
                    style={{ backgroundColor: errorNomOrganisme ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                  />
                  {errorNomOrganisme && (
                    <strong id="nom-organisme-error" role="alert" className="error">
                      <Trans>{errorNomOrganisme}</Trans>
                    </strong>
                  )}
                </FormControl>
              </div>

              <FormControl fullWidth>
                <FormLabel required id="radio-gre-a-gre-group-label">
                  <Trans>
                    {t(
                      "formulairePlaintes.renseignementsContextePlainte.lblChampAppelOffreContrat"
                    )}
                  </Trans>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="radio-gre-a-gre-group-label"
                  name="typeDemande"
                  onChange={handleOnChangeTypeDemande}
                  style={{ backgroundColor: errorTypeDemande ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                >
                  <FormControlLabel
                    value={Processus.Adjudication}
                    control={<Radio />}
                    label={
                      <Trans>
                        {" "}
                        {t(
                          "formulairePlaintes.renseignementsContextePlainte.lblChampAppelOffreContratRadioAppelOffre"
                        )}
                      </Trans>
                    }
                  />
                  <FormControlLabel
                    value={Processus.Attribution}
                    control={<Radio />}
                    label={
                      <Trans>
                        {t(
                          "formulairePlaintes.renseignementsContextePlainte.lblChampAppelOffreContratRadioContrat"
                        )}
                      </Trans>
                    }
                    aria-describedby="type-demande-error"
                  />
                </RadioGroup>
              </FormControl>
              {errorTypeDemande && (
                <strong id="type-demande-error" role="alert" className="error">
                  <Trans>{errorTypeDemande}</Trans>
                </strong>
              )}

              {plainte.typeDemande === Processus.Adjudication ? (
                <>
                  <FormControl fullWidth>
                    <FormLabel id="porterPlainteOrganismePublicAvantAMP-label">
                      <Trans>
                        {t(
                          "formulairePlaintes.renseignementsContextePlainte.typeDemandeAdjudication.lblPorterPlainteOrganismePublic"
                        )}
                      </Trans>
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="porterPlainteOrganismePublicAvantAMP-label"
                      name="porterPlainteOrganismePublicAvantAMP"
                      onChange={handleOuiNonQuestionChange}
                    >
                      <FormControlLabel
                        value="oui"
                        control={<Radio />}
                        label={<Trans>{t('Oui')}</Trans>}
                      />
                      <FormControlLabel
                        value="non"
                        control={<Radio />}
                        label={<Trans>{t('Non')}</Trans>}
                      />
                    </RadioGroup>
                  </FormControl>
                  <div className="form-div-no-margin">
                    <FormControl fullWidth>
                      <TextField
                        name="numeroDossierDetailsOrganismePublic"
                        label={
                          <Trans>
                            {t(
                              "formulairePlaintes.renseignementsContextePlainte.typeDemandeAdjudication.lblNumeroDossier"
                            )}
                          </Trans>
                        }

                        onChange={handleOnChange}
                        value={decodeHtmlEntities(plainte.numeroDossierDetailsOrganismePublic || '')}
                      />
                    </FormControl>
                  </div>
                </>
              ) : plainte.typeDemande === Processus.Attribution ? (
                <FormControl fullWidth>
                  <FormLabel id="interetRealiserContrat-label">
                    <Trans>
                      {t(
                        "formulairePlaintes.renseignementsContextePlainte.typeDemandeAttribution.lblInteretRealiseContrat"
                      )}
                    </Trans>
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="interetRealiserContrat-label"
                    name="interetRealiserContrat"
                    onChange={handleOuiNonQuestionChange}
                  >
                    <FormControlLabel
                      value="oui"
                      control={<Radio />}
                      label={<Trans>{t('Oui')}</Trans>}
                    />
                    <FormControlLabel
                      value="non"
                      control={<Radio />}
                      label={<Trans>{t('Non')}</Trans>}
                    />
                  </RadioGroup>
                </FormControl>
              ) : null}

              <FormControl fullWidth>
                <FormLabel id="recuDecisionOrganismePublic-label">
                  <Trans>
                    {t(
                      "formulairePlaintes.renseignementsContextePlainte.lblDecisionRecueOrganismePublic"
                    )}
                  </Trans>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="recuDecisionOrganismePublic-label"
                  name="recuDecisionOrganismePublic"
                  onChange={handleOuiNonQuestionChange}
                >
                  <FormControlLabel value="oui" control={<Radio />} label={<Trans>{t('Oui')}</Trans>} />
                  <FormControlLabel value="non" control={<Radio />} label={<Trans>{t('Non')}</Trans>} />
                </RadioGroup>
              </FormControl>
              <FormControl>
                {plainte.recuDecisionOrganismePublic ? (
                  <>
                    <FormControl>
                      <FormLabel>
                        <Trans>
                          {t(
                            "formulairePlaintes.renseignementsContextePlainte.lblDateReceptionDecision"
                          )}
                        </Trans>
                      </FormLabel>
                      <DatePicker
                        disableFuture={true}
                        value={plainte.dateDeReceptionDetailsOrganismePublic !== null ? new Date(plainte.dateDeReceptionDetailsOrganismePublic) : null}
                        onChange={(value): void => onChangeDateReception(value)}
                      />
                    </FormControl>
                  </>
                ) : null}
              </FormControl>

              <RepresentantOrganismePublicCRUDForm
                representantsOrganismePublic={
                  plainte.representantsOrganismePublic
                }
                onChange={handleOnRepresentantOPChange}
              />
            </fieldset>
            <fieldset className="identification-select">
              <legend>

                <Trans>
                  {t("formulairePlaintes.identificationMotifPlainte.lblSection")}
                </Trans>

              </legend>

              {plainte.typeDemande !== Processus.Adjudication && plainte.typeDemande !== Processus.Attribution ? (
                <>
                  <FormLabel>
                    <Trans>
                      {t(
                        "formulairePlaintes.identificationMotifPlainte.messageChampNonRempli"
                      )}
                    </Trans>
                  </FormLabel>
                </>) : null}

              {plainte.typeDemande === Processus.Adjudication ? (
                <>
                  <FormControl fullWidth>
                    <div className="form-text-label-no-margin">
                      <Trans>
                        {t(
                          "formulairePlaintes.identificationMotifPlainte.adjudication.lblMessage"
                        )}
                      </Trans>
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="desaccordDecision"
                          checked={plainte.desaccordDecision ?? false}
                          onChange={handleOuiNonCheckboxMotifPlainteChange}
                        />
                      }
                      label={
                        <Trans>
                          {t(
                            "formulairePlaintes.identificationMotifPlainte.adjudication.lblDesaccordDecision"
                          )}
                        </Trans>
                      }
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="decisionNonRecue"
                          checked={plainte.decisionNonRecue ?? false}
                          onChange={handleOuiNonCheckboxMotifPlainteChange}
                        />
                      }
                      label={
                        <Trans>
                          {t(
                            "formulairePlaintes.identificationMotifPlainte.adjudication.lblDecisionNonRecue"
                          )}
                        </Trans>
                      }
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="documentsModifiesDurantPeriodeAvantDateLimiteOuAvisIntentionNonPublie"
                          checked={
                            plainte.documentsModifiesDurantPeriodeAvantDateLimiteOuAvisIntentionNonPublie ??
                            false
                          }
                          onChange={handleOuiNonCheckboxMotifPlainteChange}
                        />
                      }
                      label={
                        <Trans>
                          {t(
                            "formulairePlaintes.identificationMotifPlainte.adjudication.lblDocumentsModifies"
                          )}
                        </Trans>
                      }
                    />

                  </FormControl>
                </>
              ) : plainte.typeDemande === Processus.Attribution ? (
                <>
                  <FormControl fullWidth>
                    <div className="form-text-label-no-margin">
                      <Trans>
                        {t(
                          "formulairePlaintes.identificationMotifPlainte.attribution.lblMessage"
                        )}
                      </Trans>
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="desaccordDecision"
                          checked={plainte.desaccordDecision ?? false}
                          onChange={handleOuiNonCheckboxMotifPlainteChange}
                        />
                      }
                      label={
                        <Trans>
                          {t(
                            "formulairePlaintes.identificationMotifPlainte.attribution.lblDesaccordDecision"
                          )}
                        </Trans>
                      }
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="decisionNonRecue"
                          checked={plainte.decisionNonRecue ?? false}
                          onChange={handleOuiNonCheckboxMotifPlainteChange}
                        />
                      }
                      label={
                        <Trans>
                          {t(
                            "formulairePlaintes.identificationMotifPlainte.attribution.lblDecisionNonRecue"
                          )}
                        </Trans>
                      }
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="documentsModifiesDurantPeriodeAvantDateLimiteOuAvisIntentionNonPublie"
                          checked={
                            plainte.documentsModifiesDurantPeriodeAvantDateLimiteOuAvisIntentionNonPublie ??
                            false
                          }
                          onChange={handleOuiNonCheckboxMotifPlainteChange}
                        />
                      }
                      label={
                        <Trans>
                          {t(
                            "formulairePlaintes.identificationMotifPlainte.attribution.lblDocumentsModifies"
                          )}
                        </Trans>
                      }
                    />

                  </FormControl>
                </>
              ) : null}
            </fieldset>
            <fieldset>
              <legend>

                <Trans>
                  {t("formulairePlaintes.renseignementsProcessus.lblSection")}
                </Trans>

              </legend>

              <AppelOffreForm
                appelOffre={plainte.appelOffre}
                typeDemande={plainte.typeDemande}
                onChange={handleSEAOFormChange}
                onBlur={handleFormatErrors}
                errorNumeroReference={errorNumeroReference}
              />
            </fieldset>
            <fieldset>
              <legend>

                <Trans>
                  {t("formulairePlaintes.descriptionMotifsPlainte.lblSection")}
                </Trans>

              </legend>

              <FormControl fullWidth>
                <div>
                  <FormLabel>
                    <Trans>
                      {t(
                        "formulairePlaintes.descriptionMotifsPlainte.messageSection"
                      )}
                    </Trans>
                  </FormLabel>
                </div>
                <TextField
                  name="motifsPlainte"
                  label={
                    <Trans>
                      {t(
                        "formulairePlaintes.descriptionMotifsPlainte.lblMotifsPlainte"
                      )}
                    </Trans>
                  }

                  multiline
                  rows={4}
                  onChange={handleOnChange}
                  value={decodeHtmlEntities(plainte.motifsPlainte || '')}
                />
              </FormControl>
              <FormControl fullWidth>
                <TextField
                  name="titresDocumentsTouches"
                  label={
                    <Trans>
                      {t(
                        "formulairePlaintes.descriptionMotifsPlainte.lblTitreDocuments"
                      )}
                    </Trans>
                  }
                  multiline
                  rows={4}
                  onChange={handleOnChange}
                  value={decodeHtmlEntities(plainte.titresDocumentsTouches || '')}
                />
              </FormControl>
              <FormControl fullWidth>
                <TextField
                  name="documentsTouches"
                  label={
                    <Trans>
                      {t(
                        "formulairePlaintes.descriptionMotifsPlainte.lblDocuments"
                      )}
                    </Trans>
                  }

                  multiline
                  rows={4}
                  onChange={handleOnChange}
                  value={decodeHtmlEntities(plainte.documentsTouches || '')}
                />
              </FormControl>
              <div className="form-text-label">
                <Trans>
                  {t(
                    "formulairePlaintes.descriptionMotifsPlainte.messageDesaccord"
                  )}
                </Trans>
              </div>
              <FormControl fullWidth>
                <TextField
                  name="autresRenseignementsDesaccord"
                  label={
                    <Trans>
                      {t(
                        "formulairePlaintes.descriptionMotifsPlainte.lblAutresRenseignementsDesaccord"
                      )}
                    </Trans>
                  }
                  multiline
                  rows={4}
                  onChange={handleOnChange}
                  value={decodeHtmlEntities(plainte.autresRenseignementsDesaccord || '')}
                />
              </FormControl>
              <FormControl fullWidth>
                <TextField
                  name="autresRenseignementsPertinents"
                  label={
                    <Trans>
                      {t(
                        "formulairePlaintes.descriptionMotifsPlainte.lblAutresRenseignementsPertinents"
                      )}
                    </Trans>
                  }

                  multiline
                  rows={4}
                  onChange={handleOnChange}
                  value={decodeHtmlEntities(plainte.autresRenseignementsPertinents || '')}
                />
              </FormControl>
              <FormControl>
                <FormLabel id="depot-fichier-group-label" htmlFor="upload-file">
                  <div>
                    <Trans>{t("chargementFichiers.lblDepotFichier")}</Trans>
                  </div>
                </FormLabel>
                <Input
                  id="upload-file"
                  aria-labelledby="depot-fichier-group-label"
                  type="file"
                  inputProps={{ accept: "image/png, image/jpeg, application/pdf, .doc,.docx,.xls,.xlsx,.msg,.gif,.txt" }}
                  onChange={handleFileSelect}
                  aria-describedby="fichier-error"
                  style={{ backgroundColor: errorFichier ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                />
              </FormControl>
              {errorFichier && (
                <strong id="fichier-error" role="alert" className="error">
                  <Trans>{errorFichier}</Trans>
                </strong>
              )}
            </fieldset>
            {TurnstileWidget()}
            <div>
              <FormControl>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={saved}
                >
                  <Trans>
                    {t(
                      "formulairePlaintes.descriptionMotifsPlainte.ctaSoumettre"
                    )}
                  </Trans>
                  {loading && (<CircularProgress />)}
                </Button>
                {successForm && (
                  <strong id="form-success" role="alert" className="success">
                    <Trans>{successForm}</Trans>
                  </strong>
                )}
              </FormControl>
            </div>

          </Box>
        </CardContent>
      </Card >
    </>
  )
}

export default FormulairePlaintes